var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#FF8904"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6838 13.0177C24.2463 12.58 23.653 12.3341 23.0342 12.334H14.6668C14.048 12.334 13.4545 12.5798 13.0169 13.0174C12.5793 13.455 12.3335 14.0485 12.3335 14.6673V23.0347C12.3336 23.6534 12.5795 24.2468 13.0172 24.6843L23.1718 34.839C23.7021 35.3659 24.4193 35.6616 25.1668 35.6616C25.9144 35.6616 26.6316 35.3659 27.1618 34.839L34.8385 27.1623C35.3654 26.6321 35.6612 25.9149 35.6612 25.1673C35.6612 24.4198 35.3654 23.7026 34.8385 23.1723L24.6838 13.0177Z",
    stroke: "#7E2A0C",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7498 19.3327C19.072 19.3327 19.3332 19.0715 19.3332 18.7493C19.3332 18.4272 19.072 18.166 18.7498 18.166C18.4277 18.166 18.1665 18.4272 18.1665 18.7493C18.1665 19.0715 18.4277 19.3327 18.7498 19.3327Z",
    fill: "#7E2A0C",
    stroke: "#7E2A0C",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanVector);
export default __webpack_public_path__ + "static/media/PlanVector.f469aff7611accf507a9688ea738a2a0.svg";
export { ForwardRef as ReactComponent };